"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxPlotTooltipStyles = void 0;
const tslib_1 = require("tslib");
/* eslint-disable camelcase */
const global_FontWeight_bold_1 = tslib_1.__importDefault(require('@patternfly/react-tokens/dist/js/global_FontWeight_bold'));
const chart_voronoi_labels_Fill_1 = tslib_1.__importDefault(require('@patternfly/react-tokens/dist/js/chart_voronoi_labels_Fill'));
/**
 * Box plot tooltip styles
 * @private
 */
exports.BoxPlotTooltipStyles = {
    flyout: {
        padding: 40
    },
    label: {
        fill: chart_voronoi_labels_Fill_1.default.var,
        fontWeight: global_FontWeight_bold_1.default.value
    }
};
//# sourceMappingURL=box-plot-tooltip-styles.js.map